var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Lesson content here.")]),_c('div',[_c('button',{attrs:{"variant":"primary"},on:{"click":_vm.goOn}},[_vm._v("Read More")])]),(!_vm.message.options.preventSkip)?_c('div',[_c('button',{attrs:{"variant":"primary"},on:{"click":_vm.goOn}},[_vm._v("Skip")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }